import { routerStyxie } from '@/router/styxieBridge'

Styxie.Initializers.MobileEmployees = routerStyxie({ actions: ['index', 'new', 'edit']})
